function constantsService () {
  var oConstants = {}

  oConstants.APP_NAME = 'Deskfy'

  // FILE UPLOAD
  oConstants.FILE_UPLOAD_MAX_CONCURRENCY = 3

  oConstants.VITALLY_API_KEY =
    'ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmhkV1FpT2lJMlpqVTRPR0psT0MwNE9XSTJMVFF6WlRFdFlUUTVaaTFrTmpNMU1tRmtNelZoWTJJaUxDSmhjR2tpT2lKbFpqY3daV015TnkwME5UTTRMVFJsTlRRdE9HSTNOQzA0TkRSaU1EbGhPVEl5TURVaUxDSnpaV01pT2lKaE1qWmlNREpqTnlKOS5TY0tmakxzeWVNMVBBeWRwOElsUnA4b2JRa0pZUWlRRkZpOVVqTFBTWGFZOg=='
  oConstants.API_KEY_PIXABAY = '1029474-efa58d2dc34fd591325539b32'

  oConstants.BASE_GOOGLE_PREVIEW_URL = 'https://docs.google.com/gview?url={0}&embedded=true'

  oConstants.INTERCOM_KEY = 'wsvnu263'
  oConstants.INTERCOM_TOUR_SETUP_PT = 117265
  oConstants.INTERCOM_TOUR_SETUP_EN = 117263

  oConstants.CACHE_EXPIRATION_SUFIX = '_expiration'
  oConstants.CACHED_RECORDS = 'CACHED_RECORDS'

  oConstants.URL_BASE_APP = '.deskfy.io'
  oConstants.URL_BACKEND = 'https://api.deskfy.io'
  oConstants.URL_BACKEND_V2 = 'https://api.deskfy.io/v2'

  oConstants.ROLLBAR_API_KEY = 'bf2d7d3ae7cb4d348bef8d854f453010'
  oConstants.ENVIRONMENT = 'production'
  oConstants.IS_SOCKET_ENABLED = true

  oConstants.URL_APP_V2 = 'https://appv2.deskfy.io/'

  if (window.devEnv) {
    oConstants.ENVIRONMENT = 'dev'
    oConstants.URL_BASE_APP = 'localhost'
    oConstants.URL_BACKEND = 'http://localhost:3000'
    oConstants.URL_BACKEND_V2 = 'http://localhost:3002/v2'
    oConstants.IS_SOCKET_ENABLED = true
    oConstants.URL_APP_V2 = 'http://localhost:5173'
  } else if (location.hostname.startsWith('qa.deskfy.io') || location.hostname.startsWith('lucas.deskfy.io')) {
    oConstants.ENVIRONMENT = 'qa'
    oConstants.URL_BACKEND = 'https://api-qa.deskfy.io'
    oConstants.URL_BACKEND_V2 = oConstants.URL_BACKEND + '/v2'
    oConstants.IS_SOCKET_ENABLED = true
    oConstants.URL_APP_V2 = 'https://qav2.deskfy.io/'
  } else if (location.hostname.startsWith('qa2.deskfy.io')) {
    oConstants.ENVIRONMENT = 'qa'
    oConstants.URL_BACKEND = 'https://api-qa2.deskfy.io'
    oConstants.URL_BACKEND_V2 = oConstants.URL_BACKEND + '/v2'
    oConstants.IS_SOCKET_ENABLED = true
    oConstants.URL_APP_V2 = 'https://qav2.deskfy.io/'
  } else if (location.hostname.indexOf('deskfy.io') !== -1) {
    oConstants.IS_SOCKET_ENABLED = true
  }

  oConstants.FACEBOOK_PROFILE_PIC_URL = 'https://graph.facebook.com/v7.0/{0}/picture'
  oConstants.FACEBOOK_POST_URL = 'https://www.facebook.com/{0}'
  oConstants.TWITTER_POST_URL = 'https://twitter.com/{0}/status/{1}'
  oConstants.LINKEDIN_POST_URL = 'https://www.linkedin.com/feed/update/{0}'

  oConstants.URL_AUTH = oConstants.URL_BACKEND + '/authentication'
  oConstants.URL_AUTH_SIGNUP = oConstants.URL_AUTH + '/signin'
  oConstants.URL_AUTH_LOGIN = oConstants.URL_AUTH + '/login'
  oConstants.URL_AUTH_SSO_LOGIN = oConstants.URL_AUTH + '/sso/authorize'
  oConstants.URL_AUTH_SSO_VALIDATE = oConstants.URL_AUTH + '/sso/validate'
  oConstants.URL_AUTH_LOGIN_MOBILE = oConstants.URL_AUTH_LOGIN + '/mobile'
  oConstants.URL_AUTH_LOGOUT = oConstants.URL_AUTH + '/logout'
  oConstants.URL_AUTH_RECOVER = oConstants.URL_AUTH + '/recover'
  oConstants.URL_AUTH_RECOVER_TOKEN = oConstants.URL_AUTH + '/reset/{0}'
  oConstants.URL_AUTH_MFA_VALIDATE = oConstants.URL_AUTH + '/mfa/validate'
  oConstants.URL_AUTH_MFA_RESEND = oConstants.URL_AUTH + '/mfa/resend'
  oConstants.URL_AUTH_PASSWORD_TOKEN = oConstants.URL_AUTH + '/password/{0}'
  oConstants.URL_AUTH_STRONG_PASSWORD_VALIDATE_TOKEN = oConstants.URL_AUTH + '/strong-password/validate/{0}'

  oConstants.URL_NEW_USERS = oConstants.URL_BACKEND + '/NewUsers'
  oConstants.URL_NEW_USERS_COUNT_STATUS = oConstants.URL_NEW_USERS + '/count/status'
  oConstants.URL_NEW_USERS_GROUPS = oConstants.URL_NEW_USERS + '/groups'
  oConstants.URL_NEW_USERS_INACTIVATE = oConstants.URL_NEW_USERS + '/inactivate'
  oConstants.URL_NEW_USERS_ACTIVATE = oConstants.URL_NEW_USERS + '/activate'
  oConstants.URL_NEW_USERS_INVITES_RESEND = oConstants.URL_NEW_USERS + '/invite/resend'
  oConstants.URL_NEW_USERS_INVITES = oConstants.URL_NEW_USERS + '/invites'
  oConstants.URL_NEW_USERS_EXPORT = oConstants.URL_NEW_USERS + '/export'
  oConstants.URL_NEW_USERS_DELETE = oConstants.URL_NEW_USERS + '/{0}'
  oConstants.URL_NEW_USERS_RESTORE = oConstants.URL_NEW_USERS + '/{0}/remove/cancel'

  oConstants.URL_RECENTS_EMAILS_SHARE_LINKS = oConstants.URL_BACKEND + '/ShareLinks/emails/recents'
  oConstants.URL_EMAILS_SHARE_LINKS = oConstants.URL_BACKEND + '/ShareLinks/emails/list'

  oConstants.URL_USERS = oConstants.URL_BACKEND + '/users'
  oConstants.URL_USERS_SIMPLIFIED = oConstants.URL_USERS + '/simplified'
  oConstants.URL_USERS_BASIC = oConstants.URL_USERS + '/basic'
  oConstants.URL_USERS_INVITE = oConstants.URL_USERS + '/invite'
  oConstants.URL_USERS_INVITE_ID_RESEND = oConstants.URL_USERS + '/invite/{0}/resend'
  oConstants.URL_USERS_IMPORT = oConstants.URL_USERS + '/import'
  oConstants.URL_USERS_EXIST_EMAIL = oConstants.URL_USERS + '/emails'
  oConstants.URL_USERS_ME = oConstants.URL_USERS + '/me'
  oConstants.URL_USERS_ME_GROUP_USERS = oConstants.URL_USERS_ME + '/owned-users'
  oConstants.URL_USERS_ME_EMAIL_CONFIRMATION_RESEND = oConstants.URL_USERS_ME + '/email/confirmation/resend'
  oConstants.URL_USERS_ME_LANGUAGE_CODE = oConstants.URL_USERS_ME + '/language'
  oConstants.URL_USERS_ME_PASSWORD = oConstants.URL_USERS_ME + '/password'
  oConstants.URL_USERS_ME_POSTS = oConstants.URL_USERS_ME + '/posts'
  oConstants.URL_USERS_ME_POSTS_OPEN_UPON_ENTRY = oConstants.URL_USERS_ME_POSTS + '/autoShowAfterLogin'
  oConstants.URL_USERS_ME_CHECK_UNREAD_POSTS = oConstants.URL_USERS_ME + '/posts/unread/count'
  oConstants.URL_USERS_ME_CONTEXTS = oConstants.URL_USERS_ME + '/contexts'
  oConstants.URL_USERS_ME_CONTEXT = oConstants.URL_USERS_ME + '/context'
  oConstants.URL_USERS_ME_COMPANIES = oConstants.URL_USERS_ME + '/companies'
  oConstants.URL_USERS_ME_COMPANY = oConstants.URL_USERS_ME + '/company'
  oConstants.URL_USERS_ME_COMPANY_CONFIGURATIONS = oConstants.URL_USERS_ME + '/company/configurations'
  oConstants.URL_USERS_ME_IMAGES = oConstants.URL_USERS_ME + '/images'
  oConstants.URL_USERS_ME_TASKS = oConstants.URL_USERS_ME + '/tasks'
  oConstants.URL_USERS_ME_TASKS_ROLE = oConstants.URL_USERS_ME_TASKS + '/role'
  oConstants.URL_USERS_ME_TASKS_ROLE_COUNT = oConstants.URL_USERS_ME_TASKS_ROLE + '/count'
  oConstants.URL_USERS_ME_WORKFLOW_HOME = oConstants.URL_USERS_ME + '/workflow/home'
  oConstants.URL_USERS_ME_WORKFLOW_HOME_COUNT = oConstants.URL_USERS_ME_WORKFLOW_HOME + '/count'
  oConstants.URL_USERS_ME_WORKFLOW_HOME_INSIGHTS = oConstants.URL_USERS_ME_WORKFLOW_HOME + '/insights'
  oConstants.URL_USERS_ARTS = oConstants.URL_USERS_ME + '/arts'
  oConstants.URL_USERS_ARTS_DIALOG_SKIP = oConstants.URL_USERS_ARTS + '/dialog/skip'
  oConstants.URL_USERS_ARTS_DIALOG_COUNT = oConstants.URL_USERS_ARTS + '/dialog/count'
  oConstants.URL_USERS_ME_CAMPAIGNS = oConstants.URL_USERS_ME + '/campaigns'
  oConstants.URL_USERS_TEMPLATES = oConstants.URL_USERS_ME + '/templates'
  oConstants.URL_USERS_LATEST_TEMPLATES = oConstants.URL_USERS_TEMPLATES + '/latest'
  oConstants.URL_USERS_PALETTES = oConstants.URL_USERS_ME + '/palettes'
  oConstants.URL_USERS_NOTIFICATIONS = oConstants.URL_USERS_ME + '/notifications'
  oConstants.URL_USERS_METRICS_SEND = oConstants.URL_USERS_ME + '/metrics/send'
  oConstants.URL_USERS_NOTIFICATIONS_UNREAD_COUNT = oConstants.URL_USERS_NOTIFICATIONS + '/unread/count'
  oConstants.URL_USERS_ID = oConstants.URL_USERS + '/{0}'
  oConstants.URL_USERS_ID_ACTIVE = oConstants.URL_USERS_ID + '/active'
  oConstants.URL_USERS_ID_PROFILE_IMAGE = oConstants.URL_USERS_ID + '/profileImage'
  oConstants.URL_USERS_ID_PASSWORD = oConstants.URL_USERS_ID + '/password'
  oConstants.URL_USERS_FOLDERS = oConstants.URL_USERS_ME + '/folders'
  oConstants.URL_USERS_ADDRESSES = oConstants.URL_USERS_ME + '/addresses'
  oConstants.URL_USERS_LOGIN_COUNT = oConstants.URL_USERS_ME + '/logincount'
  oConstants.URL_USERS_ART_COUNT = oConstants.URL_USERS_ME + '/artcount'
  oConstants.URL_USERS_ADMINISTRATORS_DESIGNERS = oConstants.URL_USERS + '/designersandadministrators'
  oConstants.URL_USERS_ID_COMPANIES = oConstants.URL_USERS + '/{0}/companies'
  oConstants.URL_USERS_ID_COMPANIES_ALL = oConstants.URL_USERS_ID_COMPANIES + '/all'
  oConstants.URL_USERS_MENTION = oConstants.URL_USERS + '/mention'
  oConstants.URL_USERS_HAS_DATA = oConstants.URL_USERS + '/{0}/hasdata'
  oConstants.URL_USERS_INACTIVATE = oConstants.URL_USERS + '/{0}/inactivate'
  oConstants.URL_USERS_GET_INVITATION = oConstants.URL_USERS + '/{0}/token'
  oConstants.URL_USERS_FEATURES = oConstants.URL_USERS + '/features'
  oConstants.URL_USER_CONTEXT_UPDATE = oConstants.URL_USERS_ID + '/context'

  oConstants.URL_NOTIFICATIONS = oConstants.URL_BACKEND + '/Notifications'
  oConstants.URL_NOTIFICATIONS_ID = oConstants.URL_NOTIFICATIONS + '/{0}'
  oConstants.URL_NOTIFICATIONS_CLEAR_NEW = oConstants.URL_NOTIFICATIONS + '/clear'

  oConstants.URL_FOLDERS = oConstants.URL_BACKEND + '/Folders'
  oConstants.URL_FOLDERS_ID = oConstants.URL_FOLDERS + '/{0}'
  oConstants.URL_FOLDERS_ARTS = oConstants.URL_FOLDERS_ID + '/arts'

  oConstants.URL_SCHEDULED_SHARE = oConstants.URL_BACKEND + '/ScheduledArtShares'
  oConstants.URL_SCHEDULED_SHARE_ID = oConstants.URL_SCHEDULED_SHARE + '/{0}'
  oConstants.URL_SCHEDULED_SHARE_ART_ID = oConstants.URL_SCHEDULED_SHARE + '/art/{0}'

  oConstants.URL_PRINT_SHOPS = oConstants.URL_BACKEND + '/PrintShops'
  oConstants.URL_PRINT_SHOPS_ID = oConstants.URL_PRINT_SHOPS + '/{0}'
  oConstants.URL_PRINT_SHOPS_ART_ID = oConstants.URL_PRINT_SHOPS + '/art/{0}'

  oConstants.URL_ART_COLLECTIONS = oConstants.URL_BACKEND + '/ArtCollections'
  oConstants.URL_ART_COLLECTIONS_ALL = oConstants.URL_ART_COLLECTIONS + '/all'
  oConstants.URL_ART_COLLECTIONS_SECTIONS = oConstants.URL_ART_COLLECTIONS + '/sections'
  oConstants.URL_ART_COLLECTIONS_SECTION = oConstants.URL_ART_COLLECTIONS + '/section'
  oConstants.URL_ART_COLLECTIONS_COLLECTION = oConstants.URL_ART_COLLECTIONS + '/collection'
  oConstants.URL_ART_COLLECTIONS_HIGHLIGHTED = oConstants.URL_ART_COLLECTIONS + '/highlighted'
  oConstants.URL_ART_COLLECTIONS_ALLOWED_GROUPS = oConstants.URL_ART_COLLECTIONS + '/allowed-groups'
  oConstants.URL_ART_COLLECTIONS_COLLECTION_ID = oConstants.URL_ART_COLLECTIONS_COLLECTION + '/{0}'
  oConstants.URL_ART_COLLECTIONS_SECTION_ID = oConstants.URL_ART_COLLECTIONS_SECTION + '/{0}'
  oConstants.URL_ART_COLLECTIONS_ID = oConstants.URL_ART_COLLECTIONS + '/{0}'
  oConstants.URL_ART_COLLECTIONS_ID_HAS_EXPIRATION = oConstants.URL_ART_COLLECTIONS_ID + '/has-expiration'
  oConstants.URL_ART_COLLECTIONS_ID_COLLECTIONS = oConstants.URL_ART_COLLECTIONS_ID + '/collections'
  oConstants.URL_ART_COLLECTIONS_ID_TEMPLATES = oConstants.URL_ART_COLLECTIONS_ID + '/templates'
  oConstants.URL_ART_COLLECTIONS_ID_ARCHIVE = oConstants.URL_ART_COLLECTIONS_ID + '/archive'
  oConstants.URL_ART_COLLECTIONS_ID_UNARCHIVE = oConstants.URL_ART_COLLECTIONS_ID + '/unarchive'
  oConstants.URL_ART_COLLECTIONS_ID_HIGHLIGHT = oConstants.URL_ART_COLLECTIONS_ID + '/highlight'
  oConstants.URL_ART_COLLECTIONS_ID_MOVE = oConstants.URL_ART_COLLECTIONS_ID + '/move'
  oConstants.URL_ART_COLLECTIONS_ID_PRODUCTS = oConstants.URL_ART_COLLECTIONS_ID + '/products'
  oConstants.URL_ART_COLLECTIONS_ID_THUMBNAIL = oConstants.URL_ART_COLLECTIONS_ID + '/thumbnail'
  oConstants.URL_ART_COLLECTIONS_SEARCH = oConstants.URL_ART_COLLECTIONS + '/search'
  oConstants.URL_ART_COLLECTIONS_NOTIFICATE = oConstants.URL_ART_COLLECTIONS_ID + '/notificate'
  oConstants.URL_ART_COLLECTIONS_ID_PATH = oConstants.URL_ART_COLLECTIONS_ID + '/path'
  oConstants.URL_ART_COLLECTIONS_ID_ORDER = oConstants.URL_ART_COLLECTIONS_ID + '/order'
  oConstants.URL_ART_COLLECTIONS_ID_SEGMENTATION = oConstants.URL_ART_COLLECTIONS_ID + '/segmentation/info'
  oConstants.URL_ART_COLLECTIONS_ID_BIND_COLLECTIONS = oConstants.URL_ART_COLLECTIONS_ID + '/bind-campaign'
  oConstants.URL_ART_COLLECTIONS_ID_UNBIND_COLLECTIONS = oConstants.URL_ART_COLLECTIONS_ID + '/unbind-campaign'
  oConstants.URL_ART_COLLECTIONS_MOVE_MULTIPLE = oConstants.URL_ART_COLLECTIONS + '/move'
  oConstants.URL_ART_COLLECTIONS_ARCHIVE_MULTIPLE = oConstants.URL_ART_COLLECTIONS + '/archive/batch'
  oConstants.URL_ART_COLLECTIONS_ID_INSIDE_CAMPAIGN = oConstants.URL_ART_COLLECTIONS_ID + '/inside-campaign'
  oConstants.URL_ART_COLLECTIONS_ID_HAS_LINKED_MATERIALS_IN_CAMPAIGN = oConstants.URL_ART_COLLECTIONS_ID + '/has-linked-materials-in-campaign'

  oConstants.URL_ARTS = oConstants.URL_BACKEND + '/Arts'
  oConstants.URL_ARTS_MERGE = oConstants.URL_ARTS + '/merge'
  oConstants.URL_ARTS_ARCHIVE_BATCH = oConstants.URL_ARTS + '/archive/batch'
  oConstants.URL_ARTS_UNARCHIVE_BATCH = oConstants.URL_ARTS + '/unarchive/batch'
  oConstants.URL_ARTS_SETTINGS_BATCH = oConstants.URL_ARTS + '/settings/batch'
  oConstants.URL_ARTS_APPROVALS = oConstants.URL_ARTS + '/approvals'
  oConstants.URL_ARTS_ID = oConstants.URL_ARTS + '/{0}'
  oConstants.URL_ARTS_PREVIEW = oConstants.URL_ARTS_ID + '/preview'
  oConstants.URL_ARTS_ID_DETAILS = oConstants.URL_ARTS_ID + '/details'
  oConstants.URL_ARTS_ID_FONTS = oConstants.URL_ARTS_ID + '/fonts'
  oConstants.URL_ARTS_CONVERT_TEMPLATE = oConstants.URL_ARTS + '/{0}/convertToTemplate'
  oConstants.URL_ARTS_UPDATE_TEMPLATE_SETTINGS = oConstants.URL_ARTS + '/{0}/updateTemplateSettings'
  oConstants.URL_ARTS_ARTID_SETTINGS = oConstants.URL_ARTS_ID + '/settings'
  oConstants.URL_ARTS_UPDATE_TEMPLATE_INSTRUCTIONS = oConstants.URL_ARTS + '/{0}/updateTemplateInstructions'
  oConstants.URL_ARTS_ARCHIVE_TEMPLATE = oConstants.URL_ARTS + '/{0}/archive'
  oConstants.URL_ARTS_UPDATE_VERSION = oConstants.URL_ARTS + '/{0}/updateVersion'
  oConstants.URL_ARTS_FINISH_VERSION = oConstants.URL_ARTS + '/{0}/finishArtVersion'
  oConstants.URL_ARTS_APPROVE = oConstants.URL_ARTS + '/{0}/approve'
  oConstants.URL_ARTS_DISAPPROVE = oConstants.URL_ARTS + '/{0}/disapprove'
  oConstants.URL_ARTS_REJECT = oConstants.URL_ARTS + '/{0}/reject'
  oConstants.URL_ARTS_SEND_TO_APPROVAL = oConstants.URL_ARTS + '/{0}/sendToApproval'
  oConstants.URL_ARTS_SEND_TO_DESIGNING = oConstants.URL_ARTS + '/{0}/sendToDesiging'
  oConstants.URL_ARTS_BATCH_DELETE = oConstants.URL_ARTS + '/batchDelete'
  oConstants.URL_ARTS_BATCH_ARCHIVE = oConstants.URL_ARTS + '/batchArchive'
  oConstants.URL_ARTS_UPDATE_ART_SIZE = oConstants.URL_ARTS_ID + '/resizeArt'
  oConstants.URL_ARTS_APPROVAL_COMMENTS = oConstants.URL_ARTS_ID + '/approvalComments'
  oConstants.URL_ARTS_APPROVAL_HISTORY = oConstants.URL_ARTS_ID + '/approvalHistory'
  oConstants.URL_ARTS_PINS = oConstants.URL_ARTS_ID + '/pins'
  oConstants.URL_ARTS_DOWNLOAD = oConstants.URL_ARTS_ID + '/download'
  oConstants.URL_ARTS_DUPLICATE = oConstants.URL_ARTS_ID + '/duplicate'
  oConstants.URL_ARTS_SET_FOLDER = oConstants.URL_ARTS + '/setFolder/{0}'
  oConstants.URL_ARTS_REMOVE_FOLDER = oConstants.URL_ARTS + '/removeFolder'
  oConstants.URL_ARTS_LAYER = oConstants.URL_ARTS_ID + '/artLayers'
  oConstants.URL_ARTS_LAYER_ID = oConstants.URL_ARTS_LAYER + '/{1}'
  oConstants.URL_ARTS_THUMBNAIL_ID = oConstants.URL_ARTS_ID + '/thumbnail'
  oConstants.URL_ARTS_LAYERS_ID = oConstants.URL_ARTS_ID + '/layersId'
  oConstants.URL_ARTS_RENDER_ID = oConstants.URL_ARTS_ID + '/render'
  oConstants.URL_THUMBNAIL_FALLBACK = '/assets/img/icons/img-placeholder.png'
  oConstants.URL_ARTS_ID_SOCIALSHARING = oConstants.URL_ARTS_ID + '/socialSharing'
  oConstants.URL_ARTS_ID_BUSINESSDATA = oConstants.URL_ARTS_ID + '/businessData'
  oConstants.URL_ARTS_ID_HYPERLINKS = oConstants.URL_ARTS_ID + '/hyperlinks'
  oConstants.URL_ARTS_ID_TEMPORARILY_AVAILABLE = oConstants.URL_ARTS_ID + '/temporarilyAvailable'
  oConstants.URL_ARTS_ID_PHOTOFRAMES = oConstants.URL_ARTS_ID + '/photoframes'
  oConstants.URL_ARTS_ID_BIND_CAMPAIGN = oConstants.URL_ARTS_ID + '/bind-campaign'
  oConstants.URL_ARTS_ID_UNBIND_CAMPAIGN = oConstants.URL_ARTS_ID + '/unbind-campaign'
  oConstants.URL_ARTS_UPLOAD_TEMPLATES = oConstants.URL_ARTS + '/upload-templates'
  oConstants.URL_ARTS_SETTINGS_MULTIPLE = oConstants.URL_ARTS + '/settings/multiple'
  oConstants.URL_ARTS_BATCH_DOWNLOAD = oConstants.URL_ARTS + '/batch/download'
  oConstants.URL_ARTS_BATCH_RENDER = oConstants.URL_ARTS + '/batch/render'

  oConstants.URL_SHARE_ART = oConstants.URL_ARTS_ID + '/collaborators'
  oConstants.URL_SHARE_ART_RESEND = oConstants.URL_SHARE_ART + '/{1}/resend'
  oConstants.URL_UNSHARE_ART = oConstants.URL_SHARE_ART + '/{1}'
  oConstants.URL_SHARED_ARTS = oConstants.URL_USERS_ARTS + '/shared'

  oConstants.URL_USE_TERMS = oConstants.URL_BACKEND + '/UseTerms'
  oConstants.URL_USE_TERMS_BY_ID = oConstants.URL_USE_TERMS + '/{0}'
  oConstants.URL_USE_TERMS_COUNT_IN_ARTS = oConstants.URL_USE_TERMS + '/{0}/Arts'

  oConstants.URL_ART_USE_TERMS_LOG = oConstants.URL_BACKEND + '/ArtUseTermsLog'

  oConstants.URL_ARCHIVE_ART = oConstants.URL_ARTS_ID + '/archive'
  oConstants.URL_DISARCHIVE_ART = oConstants.URL_ARTS_ID + '/unarchive'
  oConstants.URL_ARCHIVED_ARTS = oConstants.URL_USERS_ARTS + '/archived'

  oConstants.URL_PRODUCTS = oConstants.URL_BACKEND_V2 + '/formats'
  oConstants.URL_PRODUCTS_COUNT = oConstants.URL_PRODUCTS + '/count'
  oConstants.URL_EXPANDED_PRODUCTS = oConstants.URL_PRODUCTS + '/expanded'
  oConstants.URL_EXPANDED_PRODUCTS_ADMIN = oConstants.URL_EXPANDED_PRODUCTS + '/admin'
  oConstants.URL_PRODUCTS_SECTIONS = oConstants.URL_PRODUCTS + '/sections'
  oConstants.URL_CUSTOMER_PRODUCTS = oConstants.URL_PRODUCTS + '/customer'
  oConstants.URL_CUSTOMER_PRODUCTS_ID = oConstants.URL_CUSTOMER_PRODUCTS + '/{0}'
  oConstants.URL_PRODUCTS_ID = oConstants.URL_PRODUCTS + '/{0}'
  oConstants.URL_PRODUCTS_ID_TEMPLATES = oConstants.URL_PRODUCTS_ID + '/templates'
  oConstants.URL_PRODUCTS_ID_THUMBNAIL = oConstants.URL_PRODUCTS_ID + '/thumbnail'
  oConstants.URL_PRODUCTS_SLUG = oConstants.URL_PRODUCTS + '/slug/{0}'
  oConstants.URL_PRODUCTS_SEARCH = oConstants.URL_PRODUCTS + '/search'
  oConstants.URL_PRODUCTS_VERIFY = oConstants.URL_PRODUCTS + '/verify'
  oConstants.URL_PRODUCTS_SUGGESTIONS = oConstants.URL_PRODUCTS + '/suggestions'

  oConstants.URL_ART_TAGS = oConstants.URL_BACKEND + '/ArtTags'
  oConstants.URL_ART_CATEGORIES_PRODUCT_ID = oConstants.URL_ART_TAGS + '/formats/{0}'

  oConstants.URL_TEMPLATES = oConstants.URL_BACKEND + '/Templates'
  oConstants.URL_TEMPLATES_ARCHIVE_CAMPAIGN = oConstants.URL_TEMPLATES + '/archive/campaign'
  oConstants.URL_TEMPLATES_UNARCHIVE_CAMPAIGN = oConstants.URL_TEMPLATES + '/unarchive/campaign'
  oConstants.URL_TEMPLATES_ID = oConstants.URL_TEMPLATES + '/{0}'
  oConstants.URL_TEMPLATES_ID_ACTIVITIES = oConstants.URL_TEMPLATES_ID + '/activities'
  oConstants.URL_TEMPLATES_ID_TAGS = oConstants.URL_TEMPLATES_ID + '/tags'
  oConstants.URL_TEMPLATES_ID_DETAILS = oConstants.URL_TEMPLATES_ID + '/details'
  oConstants.URL_TEMPLATES_ID_DETAILS_PREVIEW = oConstants.URL_TEMPLATES_ID_DETAILS + '/preview'
  oConstants.URL_TEMPLATES_ID_THUMBNAIL = oConstants.URL_TEMPLATES_ID + '/thumbnail'
  oConstants.URL_TEMPLATES_ID_MOVE = oConstants.URL_TEMPLATES_ID + '/move'
  oConstants.URL_TEMPLATES_BY_PRODUCT = oConstants.URL_PRODUCTS + '/{0}/templates'
  oConstants.URL_TEMPLATES_DETAILS_BY_PRODUCT = oConstants.URL_TEMPLATES_BY_PRODUCT + '/details'
  oConstants.URL_TEMPLATES_SEARCH = oConstants.URL_TEMPLATES + '/search'
  oConstants.URL_TEMPLATES_SEARCH_BY_NAME = oConstants.URL_TEMPLATES + '/searchByName'
  oConstants.URL_TEMPLATES_ID_ORDER = oConstants.URL_TEMPLATES_ID + '/order'
  oConstants.URL_TEMPLATES_ID_UNAVAILABLE_ARTS = oConstants.URL_TEMPLATES_ID + '/unavailableArts'
  oConstants.URL_TEMPLATES_ID_BIND_CAMPAIGN = oConstants.URL_TEMPLATES_ID + '/bind-campaign'
  oConstants.URL_TEMPLATES_ID_UNBIND_CAMPAIGN = oConstants.URL_TEMPLATES_ID + '/unbind-campaign'
  oConstants.URL_TEMPLATES_MOVE_MULTIPLE = oConstants.URL_TEMPLATES + '/move'

  oConstants.URL_ICON_CATEGORIES = oConstants.URL_BACKEND + '/IconCategories'

  oConstants.URL_ICONS = oConstants.URL_BACKEND + '/Icons'
  oConstants.URL_ICONS_BY_CATEGORY = oConstants.URL_ICONS + '/category/{0}'
  oConstants.URL_ICONS_SEARCH = oConstants.URL_ICONS + '/search/{0}'

  oConstants.URL_ASSETS = oConstants.URL_BACKEND + '/Assets'
  oConstants.URL_ASSETS_SEARCH = oConstants.URL_ASSETS + '/search'
  oConstants.URL_ASSETS_HAS_ARTS = oConstants.URL_ASSETS + '/arts'
  oConstants.URL_ASSETS_ID = oConstants.URL_ASSETS + '/{0}'
  oConstants.URL_ASSETS_ID_ARCHIVE = oConstants.URL_ASSETS_ID + '/archive'
  oConstants.URL_ASSETS_BATCH_ARCHIVE = oConstants.URL_ASSETS + '/batch/archive'
  oConstants.URL_ASSETS_ID_DETAILS = oConstants.URL_ASSETS_ID + '/details'
  oConstants.URL_ASSETS_ID_DOWNLOAD_TOKEN = oConstants.URL_ASSETS_ID + '/downloadToken'
  oConstants.URL_ASSET_COMMENT = oConstants.URL_ASSETS_ID + '/comment'
  oConstants.URL_ASSET_COMMENTS = oConstants.URL_ASSETS_ID + '/comments'
  oConstants.URL_ASSET_PINS = oConstants.URL_ASSETS_ID + '/pins'
  oConstants.URL_ASSET_COMMENT_EDIT = oConstants.URL_ASSETS + '/comment/{0}'

  oConstants.URL_DOCS = oConstants.URL_ASSETS + '/doc'
  oConstants.URL_DOCS_ID = oConstants.URL_DOCS + '/{0}'
  oConstants.URL_DOCS_ID_DOWNLOAD = oConstants.URL_DOCS_ID + '/download'

  oConstants.URL_CUSTOMER_ASSETS = oConstants.URL_ASSETS + '/company'
  oConstants.URL_CUSTOMER_ASSETS_BATCH_DELETE = oConstants.URL_ASSETS + '/company/batchDelete'
  oConstants.URL_CUSTOMER_ASSETS_ID = oConstants.URL_ASSETS + '/company/{0}'
  oConstants.URL_CUSTOMER_ASSETS_ID_STREAM = oConstants.URL_ASSETS + '/company/{0}/stream'
  oConstants.URL_CUSTOMER_ASSETS_THUMBNAIL_ID = oConstants.URL_ASSETS + '/company/{0}/thumbnail'
  oConstants.URL_CUSTOMER_ASSETS_OPTIMIZED_ID = oConstants.URL_ASSETS + '/company/{0}/optimized'
  oConstants.URL_CUSTOMER_ASSETS_ORIGINAL_ID = oConstants.URL_ASSETS + '/company/{0}/original'
  oConstants.URL_CUSTOMER_ASSETS_DOWNLOAD_ID = oConstants.URL_ASSETS + '/company/{0}/download'

  oConstants.URL_ART_IMPORT = oConstants.URL_BACKEND + '/Images/import'
  oConstants.URL_ART_IMPORT_ID = oConstants.URL_ART_IMPORT + '/{0}'
  oConstants.URL_ART_IMPORT_ID_THUMBNAIL = oConstants.URL_ART_IMPORT_ID + '/thumbnail'

  oConstants.URL_CUSTOMER_FONT_CONFIGURATION = oConstants.URL_BACKEND + '/CustomerFontConfigurations'

  oConstants.URL_CUSTOMER_COMPANIES = oConstants.URL_BACKEND + '/CustomerCompanies'
  oConstants.URL_CUSTOMER_COMPANIES_PLAN_INTEREST_EMAIL = oConstants.URL_CUSTOMER_COMPANIES + '/interest'
  oConstants.URL_CUSTOMER_COMPANIES_ID_BILLING_PACKAGE = oConstants.URL_CUSTOMER_COMPANIES + '/{0}/billing-package'
  oConstants.URL_CUSTOMER_COMPANY_USERS = oConstants.URL_CUSTOMER_COMPANIES + '/users/{0}'
  oConstants.URL_CUSTOMER_COMPANY_BACKGROUND = oConstants.URL_CUSTOMER_COMPANIES + '/{0}/background'
  oConstants.URL_CUSTOMER_COMPANY_LOGO = oConstants.URL_CUSTOMER_COMPANIES + '/{0}/logo'
  oConstants.URL_CUSTOMER_COMPANY_ID_USER_ID_EXISTS = oConstants.URL_CUSTOMER_COMPANIES + '/{0}/user/{1}/exists'
  oConstants.URL_CUSTOMER_COMPANY_LOGO_COLORED = oConstants.URL_CUSTOMER_COMPANY_LOGO + '/colored'
  oConstants.URL_CUSTOMER_COMPANY_SYMBOL_COLORED = oConstants.URL_CUSTOMER_COMPANIES + '/{0}/symbol/colored'
  oConstants.URL_CUSTOMER_COMPANY_LOGO_LOGIN = oConstants.URL_CUSTOMER_COMPANY_LOGO + '/login'
  oConstants.URL_CUSTOMER_COMPANIES_ADD_USER = oConstants.URL_CUSTOMER_COMPANIES + '/users'
  oConstants.URL_CUSTOMER_COMPANIES_METRICS_SEND = oConstants.URL_CUSTOMER_COMPANIES + '/metrics/send'
  oConstants.URL_CUSTOMER_COMPANY_GET_ACTIVE_USERS = oConstants.URL_CUSTOMER_COMPANIES + '/{0}/activeUsers'
  oConstants.URL_CUSTOMER_COMPANY_INVITATION_PENDING_RESEND_ALL_USERS =
    oConstants.URL_CUSTOMER_COMPANIES + '/{0}/invite/resend/all/users'
  oConstants.URL_CUSTOMER_COMPANY_APIKEY = oConstants.URL_CUSTOMER_COMPANIES + '/integrations/key/refresh'

  oConstants.URL_CUSTOMER_CONFIGURATIONS = oConstants.URL_BACKEND + '/CustomerCompanyConfigurations'
  oConstants.URL_BOOLEAN_CONFIGURATION_TYPE = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/boolean/{0}'
  oConstants.URL_STRING_CONFIGURATION_TYPE = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/string/{0}'
  oConstants.URL_INTEGER_CONFIGURATION_TYPE = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/integer/{0}'
  oConstants.URL_CUSTOMER_CONFIGURATION_COMPANY_STATUS = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/status'
  oConstants.URL_CUSTOMER_CONFIGURATION_FEATURES = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/features/company'
  oConstants.URL_CUSTOMER_CONFIGURATION_FEATURE_DETAILS = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/feature/company/details'
  oConstants.URL_CUSTOMER_CONFIGURATION_CONFIG = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/config'
  oConstants.URL_CUSTOMER_CONFIGURATION_STRING = oConstants.URL_CUSTOMER_CONFIGURATIONS + '/config-string'

  oConstants.URL_EXTERNAL = oConstants.URL_BACKEND + '/External'
  oConstants.URL_EXTERNAL_CUSTOMER_COLOR = oConstants.URL_EXTERNAL + '/{0}/color'
  oConstants.URL_EXTERNAL_SHARE_LINK_ID = oConstants.URL_EXTERNAL + '/sharelinks/{0}'
  oConstants.URL_EXTERNAL_SHARE_FOLDER_LINK_ID = oConstants.URL_EXTERNAL + '/shareFolderlinks/{0}'
  oConstants.URL_EXTERNAL_SHARE_LINK_ID_DOWNLOAD = oConstants.URL_EXTERNAL + '/sharelinks/{0}/download'
  oConstants.URL_EXTERNAL_ASSET_UUID_DOWNLOAD = oConstants.URL_EXTERNAL + '/asset/{0}/download'
  oConstants.URL_EXTERNAL_USER_PROFILE_IMAGE = oConstants.URL_EXTERNAL + '/user/{0}/profileImage'
  oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN = oConstants.URL_EXTERNAL + '/company/{0}'
  oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN_LOGO = oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN + '/logo'
  oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN_BACKGROUND = oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN + '/background'
  oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN_LOGO_LOGIN = oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN + '/login/logo'
  oConstants.URL_EXTERNAL_COMPANY_SUBDOMAIN = oConstants.URL_EXTERNAL + '/company/{0}'
  oConstants.URL_EXTERNAL_INVITE_TOKEN = oConstants.URL_EXTERNAL + '/user/invite/{0}'
  oConstants.URL_EXTERNAL_CHECK_USER_EXISTS = oConstants.URL_EXTERNAL + '/user/{0}'
  oConstants.URL_EXTERNAL_BRIEFINGS_ATTACHMENT_DOWNLOAD = oConstants.URL_EXTERNAL + '/briefing/{0}/download'
  oConstants.URL_EXTERNAL_USER_VERIFICATION = oConstants.URL_EXTERNAL + '/user/verification'
  oConstants.URL_EXTERNAL_USER_VERIFICATION_EMAIL_RESEND = oConstants.URL_EXTERNAL + '/user/verification/email/resend'
  oConstants.URL_EXTERNAL_SSO_USER_VERIFICATION = oConstants.URL_EXTERNAL + '/sso/user/verification'
  oConstants.URL_EXTERNAL_SHARE_LINKS_THUMBNAIL_ID = oConstants.URL_EXTERNAL + '/{0}/thumbnail/{1}'
  oConstants.URL_EXTERNAL_SHARE_LINKS_DOWNLOAD_ART_PUBLIC_FOLDER = oConstants.URL_EXTERNAL + '/publicfolder/{0}/download/{1}'
  oConstants.URL_EXTERNAL_SHARE_LINKS_THUMBNAIL_ID_COLLECTION = oConstants.URL_EXTERNAL + '/collection/{0}/thumbnail/{1}'
  oConstants.URL_EXTERNAL_DOWNLOAD_MULTIPLE_ARTS = oConstants.URL_EXTERNAL + '/batch/download/{0}'

  oConstants.URL_PALETTES = oConstants.URL_BACKEND + '/Palettes'
  oConstants.URL_PALETTES_ID = oConstants.URL_PALETTES + '/{0}'
  oConstants.URL_PALETTES_ID_COLOR = oConstants.URL_PALETTES_ID + '/color'
  oConstants.URL_PALETTES_ID_COLOR_ID = oConstants.URL_PALETTES_ID + '/color/{1}'

  oConstants.URL_FONTS = oConstants.URL_BACKEND + '/Fonts'
  oConstants.URL_FONTS_ID = oConstants.URL_FONTS + '/{0}'
  oConstants.URL_FONTS_ID_DOWNLOAD = oConstants.URL_FONTS + '/{0}/download'
  oConstants.URL_FONTS_BATCH_DELETE = oConstants.URL_FONTS + '/batchDelete'
  oConstants.URL_FONTS_SEARCH = oConstants.URL_FONTS + '/search'
  oConstants.URL_FONTS_BRAND_SEARCH = oConstants.URL_FONTS + '/brand/search'

  oConstants.URL_ANALYTICS = oConstants.URL_BACKEND + '/Analytics'
  oConstants.URL_ANALYTICS_DATA = oConstants.URL_ANALYTICS + '/pages'
  oConstants.URL_ANALYTICS_DATA_GROUPS = oConstants.URL_ANALYTICS_DATA + '/group'
  oConstants.URL_ANALYTICS_DATA_PAGE_COMPONENTS = oConstants.URL_ANALYTICS_DATA + '/{0}/data'
  oConstants.URL_ANALYTICS_DATA_FRAMES = oConstants.URL_ANALYTICS_DATA + '/{0}/data/frames'
  oConstants.URL_ANALYTICS_DATA_FRAMES_DATA = oConstants.URL_ANALYTICS_DATA_PAGE_COMPONENTS + '/frames/{1}'
  oConstants.URL_ANALYTICS_DATA_FRAMES_DATA_SPREADSHEET = oConstants.URL_ANALYTICS_DATA_FRAMES_DATA + '/spreadsheet'
  oConstants.URL_ANALYTICS_DATA_PAGE_SPREADSHEET = oConstants.URL_ANALYTICS_DATA + '/{0}/data' + '/spreadsheet'
  oConstants.URL_ANALYTICS_INSIGHTS = oConstants.URL_ANALYTICS + '/insights/{0}'
  oConstants.URL_ANALYTICS_INSIGHTS_PREVIEW_ASSET = oConstants.URL_ANALYTICS + '/insights/preview-asset'
  oConstants.URL_ANALYTICS_INSIGHTS_PREVIEW_CUSTOMIZABLE_ASSET =
    oConstants.URL_ANALYTICS + '/insights/preview-customizable-asset'
  oConstants.URL_ANALYTICS_INSIGHTS_PREVIEW_CUSTOMIZABLE_APPROVAL_ASSET =
    oConstants.URL_ANALYTICS + '/insights/preview-customizable-asset-with-approval'
  oConstants.URL_ANALYTICS_INSIGHTS_PREVIEW_EXPORT = oConstants.URL_ANALYTICS + '/insights/{0}/spreadsheet'

  oConstants.URL_CUSTOMER_COMPANIES = oConstants.URL_BACKEND + '/CustomerCompanies'
  oConstants.URL_CUSTOMER_COMPANIES_STORAGE_TRACKING = oConstants.URL_BACKEND + '/CustomerCompanies/{0}/storageTracking'

  oConstants.URL_SHARE_LINKS = oConstants.URL_BACKEND + '/Sharelinks'
  oConstants.URL_SHARE_LINKS_COLLECTION = oConstants.URL_SHARE_LINKS + '/collection'
  oConstants.URL_SHARE_LINKS_COLLECTION_ID = oConstants.URL_SHARE_LINKS_COLLECTION + '/{0}'
  oConstants.URL_SHARE_LINKS_ID = oConstants.URL_SHARE_LINKS + '/{0}'
  oConstants.URL_SHARE_LINKS_ID_INVITES = oConstants.URL_SHARE_LINKS_ID + '/invites'

  oConstants.URL_TEMPORARY_FILES = oConstants.URL_BACKEND + '/TemporaryFiles'
  oConstants.URL_TEMPORARY_FILES_UUID = oConstants.URL_TEMPORARY_FILES + '/{0}'
  oConstants.URL_TEMPORARY_FILES_UUID_THUMBNAIL = oConstants.URL_TEMPORARY_FILES_UUID + '/thumbnail'

  oConstants.URL_GROUPS = oConstants.URL_BACKEND + '/Groups'
  oConstants.URL_GROUPS_SIMPLIFIED = oConstants.URL_GROUPS + '/simplified'
  oConstants.URL_GROUPS_ID = oConstants.URL_GROUPS + '/{0}'
  oConstants.URL_GROUPS_ID_LINKED_MATERIAL = oConstants.URL_GROUPS_ID + '/linkedMaterial'

  oConstants.URL_BOARDS = oConstants.URL_BACKEND + '/Boards'
  oConstants.URL_BOARDS_TASKS_DEFAULT = oConstants.URL_BOARDS + '/tasks/default'
  oConstants.URL_BOARDS_ID = oConstants.URL_BOARDS + '/{0}'
  oConstants.URL_BOARDS_ID_TASKS = oConstants.URL_BOARDS_ID + '/tasks'
  oConstants.URL_BOARDS_ID_TASKS_REQUESTERS = oConstants.URL_BOARDS_ID_TASKS + '/requesters'
  oConstants.URL_BOARDS_ID_ARCHIVED = oConstants.URL_BOARDS_ID + '/archived'
  oConstants.URL_BOARDS_ID_TASKS_METRICS = oConstants.URL_BOARDS_ID + '/tasks/metrics'
  oConstants.URL_BOARD_COLUMNS = oConstants.URL_BOARDS_ID + '/columns'
  oConstants.URL_BOARD_COLUMNS_ID = oConstants.URL_BOARD_COLUMNS + '/{0}'
  oConstants.URL_BOARD_COLUMNS_ID_TASKS = oConstants.URL_BOARD_COLUMNS + '/{0}/tasks'
  oConstants.URL_CHECK_IF_IS_LAST_CUSTOM_COLUMN = oConstants.URL_BOARD_COLUMNS + '/{0}/checkLastCustom'
  oConstants.URL_BOARD_COLUMNS_ID_COLUMN_HAS_USER = oConstants.URL_BOARD_COLUMNS_ID + '/assignees'
  oConstants.URL_ADD_GROUPS_TO_COLUMN = oConstants.URL_BOARD_COLUMNS + '/groups/{0}'
  oConstants.URL_BOARDS_ID_DUPLICATE = oConstants.URL_BOARDS_ID + '/duplicate'

  oConstants.URL_COLUMNS = oConstants.URL_BACKEND + '/Columns'
  oConstants.URL_COLUMNS_MOVE = oConstants.URL_COLUMNS + '/move'
  oConstants.URL_COLUMNS_ID = oConstants.URL_COLUMNS + '/{0}'
  oConstants.URL_COLUMNS_ID_TASKS = oConstants.URL_COLUMNS_ID + '/tasks'
  oConstants.URL_COLUMNS_ID_MOVE = oConstants.URL_COLUMNS_ID + '/move'
  oConstants.URL_COLUMNS_ID_TASKS_ARCHIVE = oConstants.URL_COLUMNS_ID_TASKS + '/archive'

  oConstants.URL_BRIEFINGS = oConstants.URL_BACKEND + '/Briefings'
  oConstants.URL_BRIEFINGS_DOWNLOAD = oConstants.URL_BACKEND + '/Briefings/{0}/download'
  oConstants.URL_BRIEFINGS_THUMBNAIL = oConstants.URL_BACKEND + '/Briefings/{0}/thumbnail'
  oConstants.URL_BRIEFING_BOARD_ID = oConstants.URL_BRIEFINGS + '/board/{0}'
  oConstants.URL_BRIEFING_ID = oConstants.URL_BRIEFINGS + '/{0}'
  oConstants.URL_BRIEFING_ID_TASKS = oConstants.URL_BRIEFING_ID + '/tasks'
  oConstants.URL_BRIEFING_ID_DUPLICATE = oConstants.URL_BRIEFING_ID + '/duplicate'
  oConstants.URL_BRIEFING_FIELD_ID = oConstants.URL_BRIEFINGS + '/field/{0}'
  oConstants.URL_BRIEFING_ATTACHMENT_DOWNLOAD = oConstants.URL_BRIEFING_ID + '/download'
  oConstants.URL_CUSTOMER_BRIEFING = oConstants.URL_BRIEFINGS + '/{0}/company'
  oConstants.URL_CUSTOMER_BRIEFINGS = oConstants.URL_BRIEFINGS + '/company'
  oConstants.URL_BRIEFING_USER = oConstants.URL_CUSTOMER_BRIEFING + '/{1}'
  oConstants.URL_CUSTOMER_BRIEFINGS_TYPES = oConstants.URL_BRIEFINGS + '/types'
  oConstants.URL_CUSTOMER_BRIEFINGS_COUNT = oConstants.URL_BRIEFINGS + '/count'
  oConstants.URL_BRIEFING_ID_BIND_CAMPAIGN = oConstants.URL_BRIEFING_ID + '/bind-campaign'
  oConstants.URL_BRIEFING_ID_UNBIND_CAMPAIGN = oConstants.URL_BRIEFING_ID + '/unbind-campaign'

  oConstants.URL_TASK_V2 = oConstants.URL_BACKEND_V2 + '/Tasks'
  oConstants.URL_TASK_V2_ID_ACTIVE_APPROVAL = oConstants.URL_TASK_V2 + '/{0}/activeApproval'
  oConstants.URL_TASK_V2_ID_APPROVALS_HISTORY = oConstants.URL_TASK_V2 + '/{0}/approvals/history'

  oConstants.URL_TASKS = oConstants.URL_BACKEND + '/Tasks'
  oConstants.URL_TASKS_ID = oConstants.URL_TASKS + '/{0}'
  oConstants.URL_TASKS_ID_DOCUMENTS = oConstants.URL_TASKS_ID + '/documents'
  oConstants.URL_TASKS_ID_DOCUMENTS_ID = oConstants.URL_TASKS_ID_DOCUMENTS + '/{1}'
  oConstants.URL_TASKS_ID_DOCUMENTS_ATTACH = oConstants.URL_TASKS_ID_DOCUMENTS + '/attach'
  oConstants.URL_TASKS_ATTACHMENTS_DOWNLOAD_BATCH = oConstants.URL_TASKS_ID + '/attachments/download/batch'
  oConstants.URL_TASKS_ID_SUBTASK = oConstants.URL_TASKS_ID + '/subtasks'
  oConstants.URL_TASKS_CALENDAR_BOARD_ID = oConstants.URL_TASKS + '/calendar/{0}'
  oConstants.URL_TASKS_ID_SUBTASK_ID = oConstants.URL_TASKS_ID_SUBTASK + '/{1}'
  oConstants.URL_TASKS_ID_SUBTASK_ID_ORDER = oConstants.URL_TASKS_ID_SUBTASK_ID + '/position'
  oConstants.URL_TASKS_ID_ASSIGNEES = oConstants.URL_TASKS_ID + '/assignees'
  oConstants.URL_TASKS_ID_ATTACHMENTS = oConstants.URL_TASKS_ID + '/attachments'
  oConstants.URL_TASKS_ID_ATTACHMENTS_USER = oConstants.URL_TASKS_ID + '/attachments/user'
  oConstants.URL_TASKS_ID_ATTACHMENTS_COUNT = oConstants.URL_TASKS_ID + '/attachments/count'
  oConstants.URL_TASKS_ID_ATTACHMENTS_BATCH = oConstants.URL_TASKS_ID + '/attachments/batch'
  oConstants.URL_TASKS_ID_ATTACHMENTS_ASSET_ID = oConstants.URL_TASKS_ID_ATTACHMENTS + '/{1}'
  oConstants.URL_TASKS_APPROVE = oConstants.URL_TASKS_ID + '/approve'
  oConstants.URL_TASKS_ID_STATUS = oConstants.URL_TASKS_ID + '/status'
  oConstants.URL_TASKS_ID_AUTHOR = oConstants.URL_TASKS_ID + '/author'
  oConstants.URL_TASKS_ID_OCCULTED = oConstants.URL_TASKS_ID + '/unset-occulted'
  oConstants.URL_TASKS_ID_RATE = oConstants.URL_TASKS_ID + '/rate'
  oConstants.URL_TASKS_ID_ACTIVITY = oConstants.URL_TASKS_ID + '/history'
  oConstants.URL_TASKS_ACTIVITY_BATCH = oConstants.URL_TASKS + '/history/batch'
  oConstants.URL_TASKS_ID_COMMENTS = oConstants.URL_TASKS_ID + '/comments'
  oConstants.URL_TASKS_ID_COMMENT = oConstants.URL_TASKS_ID + '/comment'
  oConstants.URL_TASKS_ID_COMMENT_EDIT = oConstants.URL_TASKS_ID + '/comment/{1}'
  oConstants.URL_TASKS_ID_PDF = oConstants.URL_TASKS_ID + '/pdf'
  oConstants.URL_TASKS_ID_BRIEFING = oConstants.URL_TASKS_ID + '/briefing'
  oConstants.URL_TASKS_ID_BRIEFING_VERSIONS = oConstants.URL_TASKS_ID_BRIEFING + '/versions'
  oConstants.URL_TASKS_ID_CANCEL = oConstants.URL_TASKS_ID + '/cancel'
  oConstants.URL_TASKS_ID_DISAPPROVE_DEFAULT = oConstants.URL_TASKS_ID + '/disapproveDefault'
  oConstants.URL_TASKS_ID_APPROVE_DEFAULT = oConstants.URL_TASKS_ID + '/approveDefault'
  oConstants.URL_TASKS_ID_BIND_CAMPAIGN = oConstants.URL_TASKS_ID + '/bind-campaign'
  oConstants.URL_TASKS_ID_UNBIND_CAMPAIGN = oConstants.URL_TASKS_ID + '/unbind-campaign'
  oConstants.URL_TASK_TIME_IN_COLUMN = oConstants.URL_TASKS_ID + '/timeInColumn'
  oConstants.URL_TASKS_ME = oConstants.URL_TASKS + '/me'
  oConstants.URL_TASKS_REQUESTS = oConstants.URL_TASKS + '/requests'
  oConstants.URL_TASKS_REQUESTS_STATUS = oConstants.URL_TASKS_REQUESTS + '/{0}'
  oConstants.URL_TASKS_ARCHIVED = oConstants.URL_TASKS + '/archived'
  oConstants.URL_TASKS_REQUESTS_COUNT = oConstants.URL_TASKS_REQUESTS + '/count'
  oConstants.URL_TASKS_REQUESTS_COUNT_STATUS = oConstants.URL_TASKS_REQUESTS_COUNT + '/status'
  oConstants.URL_TASKS_ATTACHMENT_PRIVATE = oConstants.URL_TASKS + '/asset/{0}/private'
  oConstants.URL_TASKS_ID_ATTACHMENT_PRIVATE_BATCH = oConstants.URL_TASKS + '/{0}/asset/private/batch'
  oConstants.URL_TASKS_ATTACHMENTS_VISUALIZED_ID = oConstants.URL_TASKS + '/{0}/attachment/{1}/view'
  oConstants.URL_TASKS_ATTACHMENTS_VISUALIZED_BATCH = oConstants.URL_TASKS + '/{0}/attachment/view/batch'
  oConstants.URL_TASKS_ID_RELATEDTASK = oConstants.URL_TASKS_ID + '/relatedtask'
  oConstants.URL_TASKS_ID_RELATEDTASK_ID = oConstants.URL_TASKS_ID_RELATEDTASK + '/{1}'
  oConstants.URL_TASKS_RECENT = oConstants.URL_TASKS + '/recent'
  oConstants.URL_TASKS_ID_TAGS = oConstants.URL_TASKS_ID + '/tags'
  oConstants.URL_TASKS_ID_MENTION = oConstants.URL_TASKS_ID + '/mention'
  oConstants.URL_TASKS_ID_DUPLICATE = oConstants.URL_TASKS_ID + '/duplicate'
  oConstants.URL_TASKS_ID_MOVE_TO_NEXT_COLUMN = oConstants.URL_TASKS_ID + '/move-to-next-column'

  oConstants.URL_TASKS_ID_UPDATE_ASSIGNEES = oConstants.URL_TASKS + '/{0}/update/assignees'

  oConstants.URL_TASK_COMMENTS_REACTIONS = oConstants.URL_BACKEND + '/TaskCommentReactions'
  oConstants.URL_TASK_COMMENTS_REACTIONS_ID = oConstants.URL_TASK_COMMENTS_REACTIONS + '/{0}/reaction'
  oConstants.URL_TASK_COMMENTS_REACTIONS_DELETE = oConstants.URL_TASK_COMMENTS_REACTIONS + '/{0}/reaction/{1}'
  oConstants.URL_TASK_COMMENTS_REACTIONS_GET = oConstants.URL_TASK_COMMENTS_REACTIONS + '/{0}/reactions'
  oConstants.URL_ASSET_COMMENTS_REACTIONS = oConstants.URL_BACKEND + '/AssetCommentReactions'
  oConstants.URL_ASSET_COMMENTS_REACTIONS_ID = oConstants.URL_ASSET_COMMENTS_REACTIONS + '/{0}/reaction'
  oConstants.URL_ASSET_COMMENTS_REACTIONS_DELETE = oConstants.URL_ASSET_COMMENTS_REACTIONS + '/{0}/reaction/{1}'
  oConstants.URL_ASSET_COMMENTS_REACTIONS_GET = oConstants.URL_ASSET_COMMENTS_REACTIONS + '/{0}/reactions'
  oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS = oConstants.URL_BACKEND + '/ApprovalInternalHistoryReactions'
  oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS_ID = oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS + '/{0}/reaction'
  oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS_DELETE = oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS + '/{0}/reaction/{1}'
  oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS_GET = oConstants.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS + '/{0}/reactions'
  oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS = oConstants.URL_BACKEND + '/ApprovalCommentReactions'
  oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS_ID = oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS + '/{0}/reaction'
  oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS_DELETE = oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS + '/{0}/reaction/{1}'
  oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS_GET = oConstants.URL_ART_APPROVAL_COMMENTS_REACTIONS + '/{0}/reactions'

  oConstants.URL_TASKS_ATTACHMENTS = oConstants.URL_TASKS_ID + '/attachments'
  oConstants.URL_TASKS_ATTACHMENTS_ID = oConstants.URL_TASKS + '/attachments/{0}'
  oConstants.URL_TASKS_ATTACHMENTS_ID_DOWNLOAD_LOGS = oConstants.URL_TASKS + '/attachments/{0}/logged-user/downloaded'

  oConstants.URL_TIMESHEETS = oConstants.URL_BACKEND + '/Timesheets'
  oConstants.URL_TIMESHEETS_TASK_ID = oConstants.URL_TIMESHEETS + '/{0}/task'
  oConstants.URL_TIMESHEETS_TASK_REPORT = oConstants.URL_TIMESHEETS + '/{0}/{1}/task/report'
  oConstants.URL_TIMESHEETS_BOARD_REPORT = oConstants.URL_TIMESHEETS + '/{0}/board/report'
  oConstants.URL_TIMESHEETS_ENTRY_ID = oConstants.URL_TIMESHEETS + '/{0}'

  oConstants.URL_APPROVALS = oConstants.URL_BACKEND + '/Approvals'
  oConstants.URL_APPROVALS_ME = oConstants.URL_APPROVALS + '/me'
  oConstants.URL_APPROVALS_ME_OVERDUE_COUNT = oConstants.URL_APPROVALS_ME + '/overdue/count'
  oConstants.URL_APPROVALS_ASSIGNABLE_USERS = oConstants.URL_APPROVALS + '/assignable-users'
  oConstants.URL_APPROVALS_V2 = oConstants.URL_BACKEND_V2 + '/Approvals'
  oConstants.URL_APPROVALS_V2_ID = oConstants.URL_APPROVALS_V2 + '/{0}'
  oConstants.URL_APPROVALS_V2_ID_STATUS = oConstants.URL_APPROVALS_V2_ID + '/status'
  oConstants.URL_APPROVALS_V2_ID_ASSET_STATUS = oConstants.URL_APPROVALS_V2 + '/{0}/asset/{1}/status'

  oConstants.URL_BUSINESS_DATA = oConstants.URL_BACKEND + '/BusinessData'
  oConstants.URL_BUSINESS_DATA_COMPANY = oConstants.URL_BACKEND + '/BusinessData/company'
  oConstants.URL_BUSINESS_DATA_FIELD = oConstants.URL_BUSINESS_DATA + '/fields'
  oConstants.URL_BUSINESS_DATA_FIELD_ID = oConstants.URL_BUSINESS_DATA + '/fields/{0}'
  oConstants.URL_BUSINESS_EDITABLE_FIELDS = oConstants.URL_BUSINESS_DATA + '/fields/editables'
  oConstants.URL_BUSINESS_ORDER_FIELDS = oConstants.URL_BUSINESS_DATA + '/fields/orders'
  oConstants.URL_BUSINESS_DATA_ID = oConstants.URL_BACKEND + '/BusinessData/{0}'
  oConstants.URL_BUSINESS_DATA_ID_THUMBNAIL = oConstants.URL_BUSINESS_DATA_ID + '/thumbnail'
  oConstants.URL_BUSINESS_DATA_ID_USER = oConstants.URL_BUSINESS_DATA_ID + '/user'
  oConstants.URL_BUSINESS_PLACEHOLDERS = oConstants.URL_BUSINESS_DATA + '/placeholders'
  oConstants.URL_BUSINESS_HAS_UPDATE = oConstants.URL_BUSINESS_DATA + '/businessArtInfo/{0}'

  oConstants.URL_PRODUCTS_FRAME = oConstants.URL_BACKEND + '/Products'
  oConstants.URL_PRODUCTS_FRAME_DELETE = oConstants.URL_PRODUCTS_FRAME + '/archive'
  oConstants.URL_PRODUCTS_FRAME_ID = oConstants.URL_BACKEND + '/Products/{0}'
  oConstants.URL_PRODUCTS_FRAME_ID_ASSET = oConstants.URL_BACKEND + '/Products/{0}/asset'

  oConstants.URL_PIXABAY = 'https://pixabay.com'
  oConstants.URL_PIXABAY_API = oConstants.URL_PIXABAY + '/api/'
  // q = query for search images
  oConstants.URL_PIXABAY_LIST_IMAGES =
    oConstants.URL_PIXABAY_API +
    '?key=' +
    oConstants.API_KEY_PIXABAY +
    '&q={0}&lang=PT&response_group=high_resolution&image_type=photo&page={1}&safesearch=true'

  oConstants.URL_PHOTOFRAMES = oConstants.URL_BACKEND + '/Photoframes'
  oConstants.URL_PHOTOFRAMES_ASSETS_DEFAULT = oConstants.URL_PHOTOFRAMES + '/assets/default'
  oConstants.URL_PHOTOFRAMES_ART_ID = oConstants.URL_PHOTOFRAMES + '/{0}'
  oConstants.URL_PHOTOFRAMES_ART_ID_COUNT = oConstants.URL_PHOTOFRAMES_ART_ID + '/count'
  oConstants.URL_PHOTOFRAMES_ART_ID_SVG_ID = oConstants.URL_PHOTOFRAMES + '/{0}/svgId'
  oConstants.URL_PHOTOFRAMES_ART_ID_ASSETS = oConstants.URL_PHOTOFRAMES_ART_ID + '/assets'
  oConstants.URL_PHOTOFRAMES_ART_ID_ASSETS_COUNT = oConstants.URL_PHOTOFRAMES_ART_ID_ASSETS + '/count'

  oConstants.URL_POSTS = oConstants.URL_BACKEND + '/Posts'
  oConstants.URL_POSTS_ARCHIVE = oConstants.URL_POSTS + '/archiveOrUnarchive'
  oConstants.URL_POSTS_CATEGORY = oConstants.URL_POSTS + '/category'
  oConstants.URL_POSTS_CATEGORY_CHILDLESS = oConstants.URL_POSTS_CATEGORY + '/childless'
  oConstants.URL_POSTS_CATEGORY_PARENTLESS = oConstants.URL_POSTS_CATEGORY + '/parentless'
  oConstants.URL_POSTS_ATTACHMENT_LOG = oConstants.URL_POSTS + '/attachmentLog'
  oConstants.URL_POSTS_ATTACHMENT_LOG_ID = oConstants.URL_POSTS_ATTACHMENT_LOG + '/{0}'
  oConstants.URL_PARENT_CATEGORIES_ID = oConstants.URL_POSTS_CATEGORY + '/{0}/parents'
  oConstants.URL_POSTS_ID_ASSETS = oConstants.URL_POSTS + '/{0}/assets'
  oConstants.URL_POSTS_ID_ASSETS_ASSETID = oConstants.URL_POSTS_ID_ASSETS + '/{1}'
  oConstants.URL_POSTS_ID_VIEWS = oConstants.URL_POSTS + '/{0}/views'

  oConstants.URL_POSTS_ID = oConstants.URL_POSTS + '/{0}'
  oConstants.URL_POSTS_ID_PIN = oConstants.URL_POSTS_ID + '/pin'
  oConstants.URL_POSTS_ID_REACT = oConstants.URL_POSTS_ID + '/react'
  oConstants.URL_POSTS_ARCHIVE_ID = oConstants.URL_POSTS_ARCHIVE + '/{0}'
  oConstants.URL_POSTS_USER_READ = oConstants.URL_POSTS + '/{0}/views'
  oConstants.URL_POSTS_ID_SEND_EMAIL = oConstants.URL_POSTS_ID + '/sendEmail'
  oConstants.URL_POSTS_ID_BIND_CAMPAIGN = oConstants.URL_POSTS_ID + '/bind-campaign'
  oConstants.URL_POSTS_ID_UNBIND_CAMPAIGN = oConstants.URL_POSTS_ID + '/unbind-campaign'

  oConstants.URL_POST_CATEGORIES = oConstants.URL_BACKEND + '/PostCategories'
  oConstants.URL_POST_CATEGORIES_BY_ID = oConstants.URL_POST_CATEGORIES + '/{0}'
  oConstants.URL_POST_CATEGORIES_EXTENDED = oConstants.URL_POST_CATEGORIES + '/extended'

  oConstants.URL_TAGS = oConstants.URL_BACKEND + '/Tags'
  oConstants.URL_TAGS_ALL = oConstants.URL_TAGS + '/'
  oConstants.URL_TAGS_ID = oConstants.URL_TAGS + '/{0}'

  oConstants.URL_REPOSITORIES = oConstants.URL_BACKEND + '/Repositories'
  oConstants.URL_REPOSITORIES_ASSETS = oConstants.URL_REPOSITORIES + '/assets'
  oConstants.URL_REPOSITORIES_ASSETS_ORGANIZED_SEARCH = oConstants.URL_REPOSITORIES_ASSETS + '/organized/search'
  oConstants.URL_REPOSITORIES_ASSETS_ID = oConstants.URL_REPOSITORIES_ASSETS + '/{0}'
  oConstants.URL_REPOSITORIES_RECENTS = oConstants.URL_REPOSITORIES_ASSETS + '/recents/{0}'
  oConstants.URL_REPOSITORIES_MODULE = oConstants.URL_REPOSITORIES_ASSETS + '/{0}'
  oConstants.URL_REPOSITORIES_ALL = oConstants.URL_REPOSITORIES_ASSETS + '/all'
  oConstants.URL_REPOSITORIES_ASSETS_ID_ARCHIVE = oConstants.URL_REPOSITORIES_ASSETS_ID + '/archive'
  oConstants.URL_REPOSITORIES_ASSETS_ID_MOVE = oConstants.URL_REPOSITORIES_ASSETS_ID + '/move'
  oConstants.URL_REPOSITORIES_ARCHIVE_BATCH = oConstants.URL_REPOSITORIES_ASSETS + '/archive/batch'
  oConstants.URL_REPOSITORIES_ASSETS_ID_USAGE = oConstants.URL_REPOSITORIES_ASSETS_ID + '/usage'
  oConstants.URL_REPOSITORIES_TRASH = oConstants.URL_REPOSITORIES + '/trash'
  oConstants.URL_REPOSITORIES_TRASH_RESTORE_ASSETID = oConstants.URL_REPOSITORIES_TRASH + '/restore/{0}'
  oConstants.URL_REPOSITORIES_TRASH_RESTORE_BATCH = oConstants.URL_REPOSITORIES_TRASH + '/restore/batch'
  oConstants.URL_REPOSITORIES_FOLDER = oConstants.URL_REPOSITORIES + '/folder'
  oConstants.URL_REPOSITORIES_FOLDER_ID = oConstants.URL_REPOSITORIES_FOLDER + '/{0}'
  oConstants.URL_REPOSITORIES_FOLDER_HISTORY = oConstants.URL_REPOSITORIES_FOLDER + '/{0}/history'
  oConstants.URL_REPOSITORIES_FOLDER_DOWNLOAD_BATCH = oConstants.URL_REPOSITORIES_FOLDER + '/download/batch'
  oConstants.URL_REPOSITORIES_COPY_LINK_BATCH = oConstants.URL_REPOSITORIES_FOLDER + '/copy-link/log/batch'
  oConstants.URL_REPOSITORIES_FOLDER_ID_PATH = oConstants.URL_REPOSITORIES_FOLDER_ID + '/path'
  oConstants.URL_REPOSITORIES_FOLDER_ID_ASSETS = oConstants.URL_REPOSITORIES_FOLDER_ID + '/assets'
  oConstants.URL_REPOSITORIES_FOLDER_ID_ARCHIVE = oConstants.URL_REPOSITORIES_FOLDER_ID + '/archive'
  oConstants.URL_REPOSITORIES_FOLDER_ID_RESTORE = oConstants.URL_REPOSITORIES_FOLDER_ID + '/restore'
  oConstants.URL_REPOSITORIES_FOLDER_ID_MOVE = oConstants.URL_REPOSITORIES_FOLDER_ID + '/move'
  oConstants.URL_REPOSITORIES_FOLDERS = oConstants.URL_REPOSITORIES + '/folders'
  oConstants.URL_REPOSITORIES_FOLDERS_MOVE_BATCH = oConstants.URL_REPOSITORIES + '/folders/move/batch'
  oConstants.URL_REPOSITORIES_ASSETS_MOVE_ASSETS = oConstants.URL_REPOSITORIES_ASSETS + '/move/batch'
  oConstants.URL_REPOSITORIES_FOLDERS_ARCHIVE_BATCH = oConstants.URL_REPOSITORIES_FOLDERS + '/archive/batch'
  oConstants.URL_REPOSITORIES_FOLDERS_RESTORE_BATCH = oConstants.URL_REPOSITORIES_FOLDERS + '/restore/batch'
  oConstants.URL_REPOSITORIES_FOLDERS_MOVE_BATCH = oConstants.URL_REPOSITORIES_FOLDERS + '/move/batch'
  oConstants.URL_REPOSITORIES_FOLDER_SEGMENTATION = oConstants.URL_REPOSITORIES_FOLDER + '/{0}/segmentation'

  oConstants.URL_CAMPAIGNS = oConstants.URL_BACKEND + '/Campaigns'
  oConstants.URL_CAMPAIGNS_ID = oConstants.URL_CAMPAIGNS + '/{0}'
  oConstants.URL_CAMPAIGNS_FINISHING_SOON = oConstants.URL_CAMPAIGNS + '/finishing/soon'
  oConstants.URL_CAMPAIGNS_ID_ARCHIVE = oConstants.URL_CAMPAIGNS_ID + '/archive'
  oConstants.URL_CAMPAIGNS_ID_UNARCHIVE = oConstants.URL_CAMPAIGNS_ID + '/unarchive'
  oConstants.URL_CAMPAIGNS_ID_STATUS = oConstants.URL_CAMPAIGNS_ID + '/status'
  oConstants.URL_CAMPAIGNS_ID_TASKS = oConstants.URL_CAMPAIGNS_ID + '/workflows'
  oConstants.URL_CAMPAIGNS_ID_POSTS = oConstants.URL_CAMPAIGNS_ID + '/posts'
  oConstants.URL_CAMPAIGNS_ID_BRIEFINGS = oConstants.URL_CAMPAIGNS_ID + '/briefings'
  oConstants.URL_CAMPAIGNS_ID_COLLECTIONS = oConstants.URL_CAMPAIGNS_ID + '/materials/collections'
  oConstants.URL_CAMPAIGNS_ID_TEMPLATES = oConstants.URL_CAMPAIGNS_ID + '/materials/templates'
  oConstants.URL_CAMPAIGNS_ID_ATTACHMENTS = oConstants.URL_CAMPAIGNS_ID + '/attachments'
  oConstants.URL_CAMPAIGNS_ID_ATTACHMENTS_ASSET_ID_UNBIND = oConstants.URL_CAMPAIGNS_ID_ATTACHMENTS + '/{1}/unbind'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS = oConstants.URL_CAMPAIGNS_ID + '/actions'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID = oConstants.URL_CAMPAIGNS_ID_ACTIONS + '/{1}'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_PUBLISH = oConstants.URL_CAMPAIGNS_ID_ACTIONS + '/publish'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_ARCHIVE = oConstants.URL_CAMPAIGNS_ID_ACTIONS + '/{1}/archive'
  oConstants.URL_CAMPAIGNS_ID_SEGMENTATION = oConstants.URL_CAMPAIGNS_ID + '/segmentation'
  oConstants.URL_USERS_ME_CAMPAIGN_ACTIONS = oConstants.URL_USERS_ME + '/campaign/actions'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_MATERIALS = oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID + '/materials'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_DELETE = oConstants.URL_CAMPAIGNS_ID_ACTIONS + '/actions/{1}'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_PUBLISH = oConstants.URL_CAMPAIGNS_ID_ACTIONS + '/publish'
  oConstants.URL_CAMPAIGNS_ID_SEGMENTATION = oConstants.URL_CAMPAIGNS_ID + '/segmentation'
  oConstants.URL_USERS_ME_CAMPAIGN_ACTIONS = oConstants.URL_USERS_ME + '/campaign/actions'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_MATERIALS = oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID + '/materials'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_MATERIALS_DOWNLOAD = oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_MATERIALS + '/download'
  oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID_UNPUBLISH = oConstants.URL_CAMPAIGNS_ID_ACTIONS_ID + '/unpublish'
  oConstants.URL_CAMPAIGNS_ID_DOCUMENTS = oConstants.URL_CAMPAIGNS_ID + '/documents'
  oConstants.URL_CAMPAIGNS_ID_DOCUMENTS_DELETE_ID = oConstants.URL_CAMPAIGNS_ID_DOCUMENTS + '/{1}'

  oConstants.URL_UI_ELEMENT_VIEW_LOG = oConstants.URL_BACKEND + '/UIElementViewLogs'
  oConstants.URL_UI_ELEMENT_VIEW_LOG_SLUG = oConstants.URL_UI_ELEMENT_VIEW_LOG + '/'

  oConstants.URL_FEATURE_RELEASE_NOTIFICATIONS = oConstants.URL_BACKEND + '/FeatureReleaseNotifications'
  oConstants.URL_FEATURE_RELEASE_NOTIFICATIONS_SLUG = oConstants.URL_FEATURE_RELEASE_NOTIFICATIONS + '/{0}'

  oConstants.URL_NEW_ASSETS = oConstants.URL_BACKEND + '/NewAssets'
  oConstants.URL_NEW_ASSETS_ID = oConstants.URL_NEW_ASSETS + '/{0}'
  oConstants.URL_NEW_ASSETS_ID_DETAILS = oConstants.URL_NEW_ASSETS_ID + '/details'
  oConstants.URL_NEW_ASSETS_ID_COPY_LINK_LOG = oConstants.URL_NEW_ASSETS_ID + '/copy-link/log'
  oConstants.URL_NEW_ASSETS_COPY_LINK_BATCH = oConstants.URL_NEW_ASSETS + '/copy-link/log/batch'
  oConstants.URL_NEW_ASSETS_ID_DOWNLOAD = oConstants.URL_NEW_ASSETS_ID + '/download'
  oConstants.URL_NEW_ASSETS_DOWNLOAD_BATCH = oConstants.URL_NEW_ASSETS + '/download/batch'
  oConstants.URL_NEW_ASSETS_PRESIGNED_UPLOAD_URL = oConstants.URL_NEW_ASSETS + '/presigned-upload-url'
  oConstants.URL_NEW_ASSETS_START_MULTIPART_UPLOAD = oConstants.URL_NEW_ASSETS + '/start-multipart-upload'
  oConstants.URL_NEW_ASSETS_MULTIPART_UPLOAD_URL = oConstants.URL_NEW_ASSETS + '/multipart-upload-url'
  oConstants.URL_NEW_ASSETS_COMPLETE_MULTIPART_UPLOAD = oConstants.URL_NEW_ASSETS + '/complete-multipart-upload'
  oConstants.URL_NEW_ASSETS_SETTINGS_BATCH = oConstants.URL_NEW_ASSETS + '/settings/batch'
  oConstants.URL_NEW_ASSETS_TAGS = oConstants.URL_NEW_ASSETS_ID + '/tags'
  oConstants.URL_NEW_ASSETS_TAGS_BATCH = oConstants.URL_NEW_ASSETS + '/tags/batch'
  oConstants.URL_NEW_ASSETS_ID_THUMBNAIL = oConstants.URL_NEW_ASSETS_ID + '/thumbnail'
  oConstants.URL_NEW_ASSETS_ID_HAS_THUMBNAIL = oConstants.URL_NEW_ASSETS_ID + '/has-thumbnail'
  oConstants.URL_NEW_ASSETS_ID_PREVIEW = oConstants.URL_NEW_ASSETS_ID + '/preview'
  oConstants.URL_NEW_ASSETS_ID_ACTIVITY = oConstants.URL_NEW_ASSETS_ID + '/history'
  oConstants.URL_NEW_ASSETS_ID_SEGMENTATION = oConstants.URL_NEW_ASSETS_ID + '/segmentation'
  oConstants.URL_NEW_ASSETS_SEGMENTATION_BATCH = oConstants.URL_NEW_ASSETS + '/segmentation/batch'
  oConstants.URL_NEW_ASSETS_ID_VERSIONS = oConstants.URL_NEW_ASSETS_ID + '/versions'
  oConstants.URL_NEW_ASSETS_ID_RESTORE_VERSION_VERSIONID = oConstants.URL_NEW_ASSETS_ID + '/restore-version/{1}'
  oConstants.URL_NEW_ASSETS_CUSTOM_FIELDS = oConstants.URL_NEW_ASSETS + '/custom-fields'
  oConstants.URL_NEW_ASSETS_ID_ASSET_CUSTOM_FIELDS_VALUE = oConstants.URL_NEW_ASSETS_ID + '/custom-fields/value'

  oConstants.URL_CONTEXTS = oConstants.URL_BACKEND + '/Contexts'
  oConstants.URL_CONTEXTS_RANDOM = oConstants.URL_CONTEXTS + '/random'
  oConstants.URL_CONTEXTS_BY_ID = oConstants.URL_CONTEXTS + '/{0}'
  oConstants.URL_CONTEXTS_ID_BUSINESS_DATA_FIELDS = oConstants.URL_CONTEXTS + '/{0}/businessDataFields'
  oConstants.URL_CONTEXTS_BY_USER_COMPANY = oConstants.URL_CONTEXTS + '/users/companies/{0}'
  oConstants.URL_CONTEXTS_BY_USER_ID = oConstants.URL_CONTEXTS + '/users/{0}'
  oConstants.URL_CONTEXTS_BY_ID_VERIFY_FIELDS = oConstants.URL_CONTEXTS_BY_ID + '/verifyFields'

  oConstants.URL_SAVED_REPLIES = oConstants.URL_BACKEND + '/SavedReplies'
  oConstants.URL_SAVED_REPLIES_ID = oConstants.URL_SAVED_REPLIES + '/{0}'

  oConstants.URL_BRAND_SECTIONS = oConstants.URL_BACKEND + '/BrandSections'
  oConstants.URL_BRAND_SECTIONS_ORDER = oConstants.URL_BRAND_SECTIONS + '/order'
  oConstants.URL_BRAND_SECTIONS_ID = oConstants.URL_BRAND_SECTIONS + '/{0}'
  oConstants.URL_BRAND_SECTIONS_ID_COUNT = oConstants.URL_BRAND_SECTIONS_ID + '/count'
  oConstants.URL_BRAND_SECTIONS_ID_CATEGORIES = oConstants.URL_BRAND_SECTIONS_ID + '/categories'
  oConstants.URL_BRAND_SECTIONS_ID_ASSETS = oConstants.URL_BRAND_SECTIONS_ID + '/assets'
  oConstants.URL_BRAND_SECTIONS_ID_ASSETS_BATCH = oConstants.URL_BRAND_SECTIONS_ID_ASSETS + '/batch'
  oConstants.URL_BRAND_SECTIONS_ID_ASSETS_ASSETID = oConstants.URL_BRAND_SECTIONS_ID_ASSETS + '/{1}'
  oConstants.URL_BRAND_SECTIONS_CATEGORIES = oConstants.URL_BACKEND + '/BrandSectionCategories'
  oConstants.URL_BRAND_SECTIONS_CATEGORIES_ID = oConstants.URL_BRAND_SECTIONS_CATEGORIES + '/{0}'
  oConstants.URL_BRAND_SECTIONS_CATEGORIES_ID_COUNT = oConstants.URL_BRAND_SECTIONS_CATEGORIES_ID + '/count'

  oConstants.URL_ASSET_TAGS = oConstants.URL_BACKEND + '/AssetTags'

  oConstants.URL_AUDITS = oConstants.URL_BACKEND + '/Audits'
  oConstants.URL_AUDITS_STATUS = oConstants.URL_AUDITS + '/status'
  oConstants.URL_AUDITS_ID = oConstants.URL_AUDITS + '/{0}'
  oConstants.URL_AUDITS_ID_ACTIVITY = oConstants.URL_AUDITS + '/{0}/activity'
  oConstants.URL_AUDITS_ID_COMMENTS = oConstants.URL_AUDITS + '/{0}/comments'
  oConstants.URL_AUDITS_ID_COMMENT_ID = oConstants.URL_AUDITS_ID_COMMENTS + '/{1}'
  oConstants.URL_AUDITS_ID_STATUS = oConstants.URL_AUDITS + '/{0}/status'
  oConstants.URL_AUDITS_ID_BRIEFING = oConstants.URL_AUDITS + '/{0}/briefing'
  oConstants.URL_AUDITS_ID_BRIEFING_VERSIONS = oConstants.URL_AUDITS_ID_BRIEFING + '/versions'
  oConstants.URL_AUDITS_ID_BRIEFING_PDF = oConstants.URL_AUDITS_ID_BRIEFING + '/pdf'
  oConstants.URL_AUDITS_ID_BRIEFING_NONCONFORMITIES = oConstants.URL_AUDITS_ID_BRIEFING + '/nonconformities'
  oConstants.URL_AUDITS_ID_RATE = oConstants.URL_AUDITS + '/{0}/rate'
  oConstants.URL_AUDITS_ID_REMINDER = oConstants.URL_AUDITS + '/{0}/reminder'
  oConstants.DEFAULT_SOCIAL_MEDIA_BRIEFING_NAME = 'Inconformidade - Redes Sociais'

  oConstants.URL_PLG = oConstants.URL_BACKEND + '/PLG'
  oConstants.URL_PLG_SIGNUP = oConstants.URL_PLG + '/signup'
  oConstants.URL_PLG_ONBOARDING_COMPANY = oConstants.URL_PLG + '/onboarding/company'
  oConstants.URL_PLG_ONBOARDING_MODULES = oConstants.URL_PLG + '/onboarding/modules'
  oConstants.URL_PLG_ONBOARDING_BRANDING = oConstants.URL_PLG + '/onboarding/branding'

  oConstants.URL_EMOJIS = oConstants.URL_BACKEND + '/Emojis'

  oConstants.URL_BUSINESS_MODELS = oConstants.URL_BACKEND + '/BusinessModels'

  oConstants.URL_BUSINESS_SEGMENTS = oConstants.URL_BACKEND + '/BusinessSegments'
  oConstants.URL_BUSINESS_SEGMENTS_ID = oConstants.URL_BUSINESS_SEGMENTS + '/{0}'
  oConstants.URL_BUSINESS_SEGMENTS_ID_ACTIVITIES = oConstants.URL_BUSINESS_SEGMENTS_ID + '/activities'

  oConstants.URL_BUSINESS_ACTIVITIES = oConstants.URL_BACKEND + '/BusinessActivities'
  oConstants.URL_BUSINESS_ACTIVITIES_ID = oConstants.URL_BUSINESS_ACTIVITIES + '/{0}'
  oConstants.URL_BUSINESS_ACTIVITIES_ID_SEGMENT = oConstants.URL_BUSINESS_ACTIVITIES_ID + '/segment'

  oConstants.URL_USERS_NOTIFICATIONS_CONFIG = oConstants.URL_BACKEND + '/UserNotifications'

  oConstants.URL_ASSET_PREVIEW = oConstants.URL_BACKEND + '/Assets/company/{0}/preview'
  oConstants.URL_ART_PREVIEW = oConstants.URL_BACKEND + '/Arts/{0}/preview/new'

  oConstants.URL_TASK_TAGS = oConstants.URL_BACKEND + '/TaskTags'
  oConstants.URL_TASK_TAGS_ID = oConstants.URL_TASK_TAGS + '/{0}'
  oConstants.URL_TASK_TAGS_SUGGESTIONS = oConstants.URL_TASK_TAGS + '/suggestions'

  oConstants.URL_GUESTS = oConstants.URL_BACKEND + '/Guest'
  oConstants.URL_GUESTS_ID = oConstants.URL_GUESTS + '/{0}'
  oConstants.URL_SHARED_WITH_GUEST = oConstants.URL_GUESTS_ID + '/shared'
  oConstants.URL_GUESTS_SUMMARY = oConstants.URL_GUESTS_ID + '/summary'
  oConstants.URL_DELETE_SHARED_WITH_GUEST = oConstants.URL_SHARED_WITH_GUEST + '/delete'
  oConstants.URL_GUESTS_REQUEST_NEW_PASSWORD = oConstants.URL_AUTH + '/guest/recoverPassword'
  oConstants.URL_GUESTS_IMPORT = oConstants.URL_GUESTS + '/import'

  oConstants.URL_SHARE = oConstants.URL_BACKEND + '/Share'
  oConstants.URL_SHARE_BRIEFING = oConstants.URL_SHARE + '/briefing/{0}'
  oConstants.URL_SHARE_BRIEFING_SUMMARY = oConstants.URL_SHARE_BRIEFING + '/summary'
  oConstants.URL_DELETE_BRIEFING_ACCESS = oConstants.URL_SHARE_BRIEFING + '/access/{1}'
  oConstants.URL_SHARE_ASSET_PACK = oConstants.URL_SHARE + '/assetPack'
  oConstants.URL_SHARE_ASSET_PACK_SHARED = oConstants.URL_SHARE_ASSET_PACK + '/{0}/shared'
  oConstants.URL_SHARE_ASSET_PACK_ASSETS = oConstants.URL_SHARE_ASSET_PACK + '/{0}/assets'
  oConstants.URL_SHARE_ASSET_PACK_ASSET_FOLDERS = oConstants.URL_SHARE_ASSET_PACK + '/{0}/folders'
  oConstants.URL_SHARE_ASSET_PACK_FOLDER_FOLDERS = oConstants.URL_SHARE_ASSET_PACK + '/{0}/folder/{1}/folders'
  oConstants.URL_SHARE_ASSET_PACK_FOLDER_ASSETS = oConstants.URL_SHARE_ASSET_PACK + '/{0}/folder/{1}/assets'
  oConstants.URL_SHARE_ASSET_PACK_SUMMARY = oConstants.URL_SHARE_ASSET_PACK + '/{0}/summary'
  oConstants.URL_SHARE_ASSET_PACK_SUMMARY_COUNT = oConstants.URL_SHARE_ASSET_PACK + '/summary/count'
  oConstants.URL_SHARE_ASSET_PACK_DOWNLOAD_SELECTED_ASSETS_AND_FOLDERS = oConstants.URL_SHARE_ASSET_PACK + '/{0}/download/batch'
  oConstants.URL_SHARE_ASSET_PACK_DOWNLOAD_ALL = oConstants.URL_SHARE_ASSET_PACK + '/{0}/download/all'
  oConstants.URL_SHARE_ASSET_PACK_UPDATE_ACCESS_EXPIRATION_DATE = oConstants.URL_SHARE_ASSET_PACK + '/{0}'
  oConstants.URL_SHARE_ASSET_PACK_DELETE = oConstants.URL_SHARE_ASSET_PACK + '/{0}'
  oConstants.URL_SHARE_ASSET_PACK_GET_ACCESS_LIST = oConstants.URL_SHARE_ASSET_PACK + '/{0}/access'
  oConstants.URL_SHARE_ASSET_PACK_DELETE_GUEST_ACCESS = oConstants.URL_SHARE_ASSET_PACK + '/{0}/access/{1}'
  oConstants.URL_SHARE_ASSET_PACK_FOLDER_PATH = oConstants.URL_SHARE_ASSET_PACK + '/{0}/folder/{1}/path'

  oConstants.URL_SOCIAL_MEDIA = oConstants.URL_BACKEND + '/SocialMedia'
  oConstants.URL_SOCIAL_MEDIA_TYPE = oConstants.URL_BACKEND + '/SocialMedia/{0}'
  oConstants.URL_SOCIAL_MEDIA_ACCOUNTS = oConstants.URL_SOCIAL_MEDIA_TYPE + '/accounts'
  oConstants.URL_SOCIAL_MEDIA_PUBLISH = oConstants.URL_SOCIAL_MEDIA_TYPE + '/publish'
  oConstants.URL_SOCIAL_MEDIA_CONTENTS = oConstants.URL_SOCIAL_MEDIA_TYPE + '/contents'
  oConstants.URL_SOCIAL_MEDIA_CONTENTS_ASSET = oConstants.URL_SOCIAL_MEDIA_CONTENTS + '/{1}'
  oConstants.URL_SOCIAL_MEDIA_POST_LIKE = oConstants.URL_SOCIAL_MEDIA + '/like/{0}'
  oConstants.URL_SOCIAL_MEDIA_AUDIT = oConstants.URL_SOCIAL_MEDIA + '/audit'
  oConstants.URL_SOCIAL_MEDIA_LAST_UPDATE = oConstants.URL_SOCIAL_MEDIA_TYPE + '/lastUpdate'
  oConstants.URL_SOCIAL_MEDIA_CONTENT_URL = oConstants.URL_SOCIAL_MEDIA_TYPE + '/preview'
  oConstants.URL_SOCIAL_MEDIA_UNLINK_ACCOUNT = oConstants.URL_SOCIAL_MEDIA + '/{0}/unlink'

  oConstants.URL_DOCUMENTS = oConstants.URL_BACKEND + '/Documents'
  oConstants.URL_DOCUMENTS_ID = oConstants.URL_DOCUMENTS + '/{0}'

  oConstants.URL_USER_FILTERS = oConstants.URL_BACKEND + '/UserFilters'
  oConstants.URL_USER_FILTERS_ID = oConstants.URL_USER_FILTERS + '/{0}'

  // API v2
  oConstants.URL_V2_BILLING = oConstants.URL_BACKEND_V2 + '/Billing'

  oConstants.URL_V2_BILLING_FEATURES = oConstants.URL_V2_BILLING + '/features'

  oConstants.URL_V2_BILLING_PRICING_PACKAGES = oConstants.URL_V2_BILLING + '/pricing-packages'
  oConstants.URL_V2_BILLING_PRICING_PACKAGES_ID = oConstants.URL_V2_BILLING + '/pricing-packages/{0}'
  oConstants.URL_V2_BILLING_PRICING_PACKAGES_ID_PLANS = oConstants.URL_V2_BILLING_PRICING_PACKAGES_ID + '/plans'
  oConstants.URL_V2_BILLING_PRICING_PACKAGES = oConstants.URL_V2_BILLING + '/pricing-packages'
  oConstants.URL_V2_BILLING_PRICING_PACKAGES_ID = oConstants.URL_V2_BILLING + '/pricing-packages/{0}'
  oConstants.URL_V2_BILLING_PRICING_PACKAGES_ID_PLANS = oConstants.URL_V2_BILLING_PRICING_PACKAGES_ID + '/plans'

  oConstants.URL_V2_BILLING_PLANS = oConstants.URL_V2_BILLING + '/plans'
  oConstants.URL_V2_BILLING_PLANS_ID = oConstants.URL_V2_BILLING_PLANS + '/{0}'
  oConstants.URL_V2_BILLING_PLANS_ID_FEATURES = oConstants.URL_V2_BILLING_PLANS_ID + '/features'
  oConstants.URL_V2_BILLING_PLANS_ID_ADDONS = oConstants.URL_V2_BILLING_PLANS_ID + '/addons'

  oConstants.URL_V2_BILLING_PACKAGE = oConstants.URL_V2_BILLING + '/billing-packages'
  oConstants.URL_V2_BILLING_PACKAGE_ID = oConstants.URL_V2_BILLING_PACKAGE + '/{0}'
  oConstants.URL_V2_BILLING_PACKAGE_ID_ADDONS = oConstants.URL_V2_BILLING_PACKAGE_ID + '/addons'

  oConstants.URL_V2_CUSTOMER_COMPANIES = oConstants.URL_BACKEND_V2 + '/customer-companies'
  oConstants.URL_V2_CUSTOMER_COMPANIES_ID = oConstants.URL_V2_CUSTOMER_COMPANIES + '/{0}'

  oConstants.URL_ART_SIZES = oConstants.URL_BACKEND_V2 + '/artSizes'
  oConstants.URL_ART_SIZES_ID = oConstants.URL_ART_SIZES + '/{0}'
  oConstants.URL_ART_SIZES_ID_FAVORITE = oConstants.URL_ART_SIZES_ID + '/favorite'
  oConstants.URL_ART_SIZES_ID_RENAME = oConstants.URL_ART_SIZES_ID + '/rename'
  oConstants.URL_ART_SIZES_ID_SELECT = oConstants.URL_ART_SIZES_ID + '/select'

  oConstants.URL_FORMATS = oConstants.URL_BACKEND_V2 + '/formats'
  oConstants.URL_FORMATS_ID = oConstants.URL_FORMATS + '/{0}'
  oConstants.URL_FORMATS_MOST_USED = oConstants.URL_BACKEND_V2 + '/formats/mostUsed'

  oConstants.URL_V2_FORMATS = oConstants.URL_BACKEND_V2 + '/formats'
  oConstants.URL_V2_FORMATS_ID = oConstants.URL_V2_FORMATS + '/{0}'
  oConstants.URL_V2_FORMATS_ID_ARTS_MIGRATE = oConstants.URL_V2_FORMATS + '/{0}/arts/migrate'
  oConstants.URL_V2_FORMATS_EXPANDED = oConstants.URL_V2_FORMATS + '/expanded'

  return oConstants
}

export { constantsService }
